/* collection-facets.js: scripts that used to be inline in snippets/new-facets-design.liquid.
   Moved to a cached asset (Oct 2026); contents unchanged, in the original order. Each block is marked with
   the line it came from in that file at the time of the move. */

/* ---- from new-facets-design.liquid line 1494 ---- */
  const monthsArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  
  function sort() {
    const arrayItems = []
  
    let getList
    if(getList != undefined){
    let elements = document.getElementsByTagName('legend')
    for(let i in elements) {
      if(elements[i].textContent === 'Birthstone') {
        getList = elements[i].nextElementSibling
      }
    }
    
    const array = getList.children
    for(let el in array) {
      if(typeof(array[el]) === 'object') arrayItems.push(array[el])
    }
  }
    const months = []
    const stones = []
  
    for(let el in arrayItems) {
      if(array[el].querySelector("input[name='filter.p.m.my_fields.birthstone']") != null){
      const elValue = array[el].querySelector("input[name='filter.p.m.my_fields.birthstone']").value
      
      
      if(monthsArray.includes(elValue)) {
        months.push(arrayItems[el])
      
      }
      else {
        stones.push(arrayItems[el])
      }
      }
    }

    months.sort((a, b) => {
      return monthsArray.indexOf(a.querySelector("input[name='filter.p.m.my_fields.birthstone']").value) - monthsArray.indexOf(b.querySelector("input[name='filter.p.m.my_fields.birthstone']").value);
    })

    const mergedArrays = [...months, ...stones]

    for(let el in mergedArrays) {
      getList.appendChild(mergedArrays[el])
    }
    
    return
  }

  function sortMobile() {
    let getMobileList = document.getElementById('FacetFiltersFormMobile').querySelector('div').querySelector('.mobile-facets__main').children
    let birthstoneList
    
    for(let i in getMobileList) {
      let el
      if(getMobileList[i] instanceof HTMLElement) el = getMobileList[i].querySelector('summary div span')?.innerHTML 

      if(el === 'Birthstone') {
        birthstoneList = getMobileList[i].querySelector('div ul')
      }
    }

    const arrayMobileItems = []
    if (birthstoneList) { 
    for(let el in birthstoneList.children) {
      if(typeof(birthstoneList.children[el]) === 'object') arrayMobileItems.push(birthstoneList.children[el])
    }
    }
    const months = []
    const stones = []
  
    for(let el in arrayMobileItems) {
      if(arrayMobileItems[el].querySelector("input[name='filter.p.m.my_fields.birthstone']") !=null){
      const elValue = arrayMobileItems[el].querySelector("input[name='filter.p.m.my_fields.birthstone']").value
      
      if(monthsArray.includes(elValue)) {
        months.push(arrayMobileItems[el])
      }else {
        stones.push(arrayMobileItems[el])
      }
      }
    }

    months.sort((a, b) => {
      return monthsArray.indexOf(a.querySelector("input[name='filter.p.m.my_fields.birthstone']").value) - monthsArray.indexOf(b.querySelector("input[name='filter.p.m.my_fields.birthstone']").value);
    })

    const mergedArrays = [...months, ...stones]

    for(let el in mergedArrays) {
      birthstoneList.appendChild(mergedArrays[el])
    }
    
    return
  }

  sort()
  sortMobile();




  

/* ---- from new-facets-design.liquid line 1600 ---- */
var selectedType = localStorage.getItem('gemstone_type_selected');


if (selectedType) {

    var checkboxNatural = document.getElementById('gemcheckbox1');
    var checkboxLabGrown = document.getElementById('gemcheckbox');

    // Set the checkbox states based on the localStorage data
    if (selectedType === 'Natural') {
        checkboxNatural.checked = true;
        checkboxLabGrown.checked = false;
    } else if (selectedType === 'Lab+Grown') {
       
        checkboxLabGrown.checked = true;
       checkboxNatural.checked = false;
    }
}

  function buildFilterUrl() {
    let params = [];

    // filters
    let selectedFilters = document.querySelectorAll('li.filter-selected input');

    selectedFilters.forEach((filter) => {
        if (filter.name && filter.value) {
            params.push(`${filter.name}=${encodeURIComponent(filter.value)}`);
        }
    });

    // sort (checked radio)
    let activeRadio = document.querySelector('#FacetMobile-sort-by input[type="radio"]:checked');

    if (activeRadio && activeRadio.name && activeRadio.value) {
        params.push(`${activeRadio.name}=${encodeURIComponent(activeRadio.value)}`);
    }

    let cleanedUrl = window.location.href.split('?')[0];
    let queryString = params.join('&');

    return queryString ? `${cleanedUrl}?${queryString}` : cleanedUrl;
}
$(document).on("click", ".custom_mob.filter-Collections,.custom_mob.filter-Type,.custom_mob.filter-Birthstone,.custom_mob.filter-Style,.custom_mob.filter-Gemstone ", function() {
  /* hereworking here */
if($(this).hasClass('filter-selected')){
 $(this).removeClass('filter-selected'); 
} else{
$(this).addClass('filter-selected');  
}



   var selectedVal = $('input[type="checkbox"]:checked').val();
    $('.filter_loader').css('display','flex');
   
    var finalUrl = buildFilterUrl();
    let variantUrl = finalUrl + `&view=ts-variants`; // hidden variant <select>s only
    // Agar URL end me sirf ? hai ya empty query hai
    if (finalUrl.endsWith('?') || finalUrl.split('?')[1] === '') {
        window.location.href = finalUrl;
        return; // important: AJAX stop ho jaye
    }
    console.log(`12345finalURl ${finalUrl}`);
  
    
       $.ajax({
          url: finalUrl,
          type: 'GET',
          success: function(res) {
           var productGrid = $(res).find("#product-grid").html();
            var ProductFilter = $(res).find("#FacetFiltersFormMobile").html();
           
          $("#FacetFiltersFormMobile").html(ProductFilter);
          setTimeout(function(){ openAccordian(); },500);
         
              var getFilterByLen = $('li.filter-selected').length;
          
                  if(getFilterByLen > 0){
                var getFilterBy = $('.filter_by_icon h3.filter_byh3').text();
                getFilterBy = `${getFilterBy} (${getFilterByLen})`;
                $('.filter_by_icon h3.filter_byh3').text(getFilterBy);
                  var getFilterBy1 = $('span.custom_filters_heading').text();
                  getFilterBy1 = `Filters (${getFilterByLen})`;
                $('span.custom_filters_heading').text(getFilterBy1);
                    }
               setTimeout(function(){  $('.filter_loader').css('display','none'); },300);
            if (selectedVal !== undefined) {
             $('input[type="checkbox"]').each(function() {
                if ($(this).val() === selectedVal) {
                    $(this).prop('checked', true);
                } else {
                    $(this).prop('checked', false);
                }
            });
            }  
            filterCount();
          }
      }); 

      $("body").addClass('remove_overflow');
      $.ajax({
          url: finalUrl,
          type: 'GET',
          success: function(res) {

            var $html = $(res);

            // Target element nikaalo
            var gridData = $html.find('.product-grid-container');
            $('.product-grid-container').html(gridData.html());
            console.log(gridData);
              window.history.pushState({}, '', finalUrl);
            // Agar inner HTML chahiye
            console.log(gridData.html());
              var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop2 ul',
                  pagination: '#Huratips-Pagination2',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
              });

               var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop',
                  pagination: '#Huratips-Pagination',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
                });
                fetchCollectionPage(variantUrl);
                myfunction()
                setTimeout(()=>{

                     $(".grid__item").each(function () {
                          initGridItemHover($(this));
                      });
                },1500)
                
          }
         
        })

 function myfunction() {

                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));     
                


                
                $('.slider.slider-products:not(.slick-initialized):not(.ts-snap)').slick({
                        dots: true,
                        infinite: true,
                        responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                          infinite: true,
                            dotsClass: 'custom_paging'
                          }
                        }
                      ]
                        
                  });

   
            }

    })

$(document).on("click", ".custom_mob.filter-Metal ", function() {
$(".custom_mob.filter-Metal").removeClass('filter-selected');
$(this).addClass('filter-selected');

 $('.filter_loader').css('display','flex');
$(this).addClass('filter-selected');


    var finalUrl = buildFilterUrl();
    // Agar URL end me sirf ? hai ya empty query hai
    if (finalUrl.endsWith('?') || finalUrl.split('?')[1] === '') {
        window.location.href = finalUrl;
        return; // important: AJAX stop ho jaye
    }
    console.log(`12345finalURl ${finalUrl}`);

    let variantUrl = finalUrl + `&view=ts-variants`; // hidden variant <select>s only
    console.log(`variantUrl is op=>`+variantUrl);
    $("body").addClass('remove_overflow');
      $.ajax({
          url: finalUrl,
          type: 'GET',
          success: function(res) {

            var $html = $(res);
            $('.filter_loader').css('display','none');
            // Target element nikaalo
            var gridData = $html.find('.product-grid-container');
            $('.product-grid-container').html(gridData.html());
            console.log(gridData);
              window.history.pushState({}, '', finalUrl);
            // Agar inner HTML chahiye
            console.log(gridData.html());
              var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop2 ul',
                  pagination: '#Huratips-Pagination2',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
              });

               var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop',
                  pagination: '#Huratips-Pagination',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
                });

                fetchCollectionPage(variantUrl);
          }
         
        })


 function myfunction() {

                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));     
                


                
                $('.slider.slider-products:not(.slick-initialized):not(.ts-snap)').slick({
                        dots: true,
                        infinite: true,
                        responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                          infinite: true,
                            dotsClass: 'custom_paging'
                          }
                        }
                      ]
                        
                  });

   
            }
})

// Variant data per product id, shared with the grid section's script (which fetches it on load / load more).
var result = window.__tsVariantResult || (window.__tsVariantResult = {});

function fetchCollectionPage(variantUrl) {


    $.ajax({
      url: variantUrl,
      type: 'GET',
      success: function(res) {

        const doc = new DOMParser().parseFromString(res, 'text/html');

        const metals = doc.querySelectorAll('.variant-metals');
        const selects = doc.querySelectorAll('.variant_Dropdown');

        metals.forEach(el => {
          const key = el.getAttribute('data-attr');
          if (!result[key]) result[key] = {};

          if (!result[key].metals) result[key].metals = [];
          result[key].metals.push(el);
        });

        selects.forEach(el => {
          const key = el.getAttribute('data-attr');
          if (!result[key]) result[key] = {};

          result[key].select = el;
        });

        appendVariantMetal();


       
      }
    });

}    

function initGridItemHover($gridItem) {
      console.log("hover initialized????");
    var $original = $gridItem.find(".hover_img_orig");
    var $duplicate = $gridItem.find(".hover_img_dup");

    // New images
    var $hoverFalse = $gridItem.find(".hover_img_false");
    var $hoverTrue = $gridItem.find(".hover_img_true");

    var $variant = $gridItem.find(
        ".jtpl-pro-variant-cstm, .jtpl-pro-variant-cstm-gem"
    );

    // ==========================================
    // INITIAL STATE
    // ==========================================

    $duplicate.attr("style","display:none");
    $original.attr("style","display:block");

    $hoverTrue.attr("style","display:block");
    $hoverFalse.attr("style","display:none");

    // Avoid duplicate events
    $gridItem.off("mouseenter.gridHover mouseleave.gridHover");
    $variant.off("mouseenter.gridHover mouseleave.gridHover");


    // ==========================================
    // GRID ITEM HOVER
    // ==========================================

    $gridItem.on("mouseenter.gridHover", function () {

        if ($gridItem.hasClass('loaded')) {
            return;
        }

        // Original / Duplicate
        $duplicate.attr("style","display:block");
        $original.attr("style","display:none");

        // False / True
        $hoverFalse.attr("style","display:block");
        $hoverTrue.attr("style","display:none");

        $gridItem.addClass("is-hovered");

    });


    // ==========================================
    // GRID ITEM LEAVE
    // ==========================================

    $gridItem.on("mouseleave.gridHover", function () {

        // Original / Duplicate
       $duplicate.attr("style","display:none");
    $original.attr("style","display:block");

    $hoverTrue.attr("style","display:block");
    $hoverFalse.attr("style","display:none");

        $gridItem.removeClass("is-hovered");

    });


    // ==========================================
    // VARIANT / GEMSTONE HOVER
    // ==========================================

    $variant.on("mouseenter.gridHover", function () {

        if ($gridItem.hasClass('loaded')) {
            return;
        }

        // Original / Duplicate -> ULTA
        $duplicate.hide();
        $original.show();

        // False / True -> ULTA
        $hoverTrue.hide();
        $hoverFalse.show();

    });


    // ==========================================
    // VARIANT / GEMSTONE LEAVE
    // ==========================================

    $variant.on("mouseleave.gridHover", function () {

        if (
            $gridItem.is(":hover") &&
            !$gridItem.hasClass('loaded')
        ) {

            // Original / Duplicate
            $duplicate.show();
            $original.hide();

            // False / True
            $hoverFalse.hide();
            $hoverTrue.show();

        }

    });


    // ==========================================
    // LOADER REMOVE
    // ==========================================

    setTimeout(function () {

        $gridItem.removeClass('loaded');

        // Mouse abhi bhi grid ke upar hai?
        if ($gridItem.is(":hover")) {

            // Original / Duplicate
            $duplicate.show();
            $original.hide();

            // False / True
            $hoverFalse.show();
            $hoverTrue.hide();

            $gridItem.addClass("is-hovered");

        }

    }, 700);
}

function appendVariantMetal(){

  document.querySelectorAll('.grid__item').forEach(item => {

   
    if (item.dataset.variantAppended === "true") return;

    const productId = item.getAttribute('data-product-id');

    if (result[productId]) {

      const data = result[productId];

      const metals = data.metals ? data.metals[0] : null; 
      const select = data.select || null;
      // Metal swatches are rendered with the page now; only the hidden <select> is appended.
      let VariantMetals = item.querySelector('.ajax-variant-metals');
      let hiddenVariantDropdown = item.querySelector('.ajax-variant-dropdown-hidden');

      if (!hiddenVariantDropdown) return;

      if (metals && VariantMetals) {
        VariantMetals.appendChild(metals.cloneNode(true));
      }

      if (select) {
        hiddenVariantDropdown.appendChild(select.cloneNode(true));
      }

      item.dataset.variantAppended = "true";
    }

  });
  initSlick();
  sliderInitfunc();
}
function initSlick() {
        if (window.innerWidth < 768) {
            if (!$('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
              setTimeout(function(){ 
                $('.slidergem.slider-productsgem').slick({
                    dots: true,
                    arrows:false,
                    infinite: true,
                    dotsClass: 'custom_paging'
                });
                },500);
            }
        } else {
            if ($('.slidergem.slider-productsgem').hasClass('slick-initialized')) {
                $('.slidergem.slider-productsgem').slick('unslick');
            }
        }
    }

    function sliderInitfunc() { 
      if ($('.slider.slider-products:not(.ts-snap)').hasClass('slick-initialized')) {
          $('.slider.slider-products:not(.ts-snap)').slick("unslick"); 
      }
        setTimeout(function() {
          $('.slider.slider-products:not(.ts-snap)').slick({
              dots: true,
              infinite: true,
              responsive: [{
                  breakpoint: 1024,
                  settings: {
                      infinite: true,
                      dotsClass: 'custom_paging'
                  }
              }]
        
          });
        },100 );

  }
 $(document).on("change", "#FacetMobile-sort-by input[type='radio']", function () {
            $('.filter_loader').css('display','flex');
            
            console.log("here it is0078")
            var finalUrl = buildFilterUrl();
    // Agar URL end me sirf ? hai ya empty query hai
    if (finalUrl.endsWith('?') || finalUrl.split('?')[1] === '') {
        window.location.href = finalUrl;
        return; // important: AJAX stop ho jaye
    }
    console.log(`12345finalURl ${finalUrl}`);

    let variantUrl = finalUrl + `&view=ts-variants`; // hidden variant <select>s only
    console.log(`variantUrl is op=>`+variantUrl);
    $("body").addClass('remove_overflow');
      $.ajax({
          url: finalUrl,
          type: 'GET',
          success: function(res) {

            var $html = $(res);
            $('.filter_loader').css('display','none');
            // Target element nikaalo
            var gridData = $html.find('.product-grid-container');
            $('.product-grid-container').html(gridData.html());
            console.log(gridData);
              window.history.pushState({}, '', finalUrl);
            // Agar inner HTML chahiye
            console.log(gridData.html());
              var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop2 ul',
                  pagination: '#Huratips-Pagination2',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
              });

               var endlessScroll = new Ajaxinate({
                  container: '#Huratips-Loop',
                  pagination: '#Huratips-Pagination',
                  loadingText: '<div class="host"><div class="loading1 loading-0"></div><div class="loading1 loading-1"></div><div class="loading1 loading-2"></div></div>',
                  callback: myfunction
                });

                fetchCollectionPage(variantUrl);
          }
         
        })


 function myfunction() {

                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));     
                


                
                $('.slider.slider-products:not(.slick-initialized):not(.ts-snap)').slick({
                        dots: true,
                        infinite: true,
                        responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                          infinite: true,
                            dotsClass: 'custom_paging'
                          }
                        }
                      ]
                        
                  });

   
            }
            // yahin se tum apna AJAX call trigger karo
        });
$(document).on("click", ".custom_mob.filter-sort ", function() {
$(".custom_mob.filter-sort").removeClass('filter-selected');
$(this).addClass('filter-selected');
})

$(document).on("click", ".show_product_cstm button", function() {
let params = [];

    let selectedFilters = document.querySelectorAll('li.filter-selected input');

    selectedFilters.forEach((filter) => {
        let paramName = filter.name;
        let paramValue = filter.value;
        params.push(`${paramName}=${paramValue}`);
    });

     var $input = $('#Mobile-Filter-Price-GTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }

    var $input = $('#Mobile-Filter-Price-LTE');
     if ($input.val()) {
       var value = $input.val();
       var name = $input.attr('name');
       params.push(`${name}=${value}`);
    }
     var selectedRadioButton = $('input[name="sort_by"]:checked');
     var selectedValue = selectedRadioButton.val();
      var selectedName = 'sort_by';
     params.push(`${selectedName}=${selectedValue}`);

  
    let currentUrl = window.location.href;
    let cleanedUrl = currentUrl.split('?')[0];
    let queryString = params.join('&');
    var finalUrl = cleanedUrl + '?' + queryString;



 


 var selectedVal = $('input[type="checkbox"]:checked').val();

   

  
if (selectedVal !== undefined) {
  
  if(selectedVal == "Natural" ){
    localStorage.setItem('gemstone_type_selected', 'Natural');
    var querynatural = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F107969839240&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122418312&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122680456&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78221148296&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F81001709704';
    var finalUrlNatural  = finalUrl + '&' + querynatural;
 window.location.href = finalUrlNatural; 
    
  } else if(selectedVal == "Lab+Grown"){
    localStorage.setItem('gemstone_type_selected', 'Lab+Grown');
   var queryLab = 'filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78225571976&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122549384&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F78122614920&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F84835565704&filter.p.m.custom.gemstone_accentstone=gid%3A%2F%2Fshopify%2FMetaobject%2F107778834568';
    var finalUrlLab  = finalUrl + '&' + queryLab;
 window.location.href = finalUrlLab; 
  
  } else{
    window.location.href = finalUrl;  
  }
    
} else{
 window.location.href = finalUrl; 
}
  

  
})


  

/* ---- from new-facets-design.liquid line 2258 ---- */
   
  openAccordian();
 function openAccordian(){   

 $(document).ready(function () {
    // Loop through each accordion item
    $('.accordion-item').each(function () {
        // Check if any <li> within this accordion item has the class 'filter-selected'
        if ($(this).find('li.filter-selected').length > 0) {
            // Add 'show' class to the accordion's collapse div to open it
            $(this).find('.accordion-collapse').addClass('show');
            // Ensure the button reflects the open state by setting aria-expanded to true
            $(this).find('.accordion-button').attr('aria-expanded', 'true');
        }
    });

 


   
});


 }  

/* ---- from new-facets-design.liquid line 2285 ---- */
var fullUrl = window.location.href;
if (fullUrl.includes("gemstone_accentstone")) {
  
} else {
   const checkboxes = document.querySelectorAll('input[name="gemorigin"]');

checkboxes.forEach(checkbox => {
  checkbox.checked = false;
});
    localStorage.removeItem('gemstone_type_selected');
}
  
$('.mobile-facets__clear').click(function(){
 localStorage.removeItem('gemstone_type_selected');
})  

/* ---- from new-facets-design.liquid line 2304 ---- */
   document.addEventListener('DOMContentLoaded', function() {
    const checkbox = document.getElementById('myCheckbox');
    if (checkbox) {
        checkbox.checked = true;
    }
});
    // document.addEventListener('DOMContentLoaded', function() {
    //   document.getElementById('noRadio').checked = true; // Selects the "no" radio button
    // });
  

/* ---- from new-facets-design.liquid line 2316 ---- */
        function handleCheckboxChange(event) {
            const checkboxes = document.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });
        }
    
